<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      filename="Social Solidarity"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a2"
      pdf-orientation="portrait"
      pdf-content-width="100%"
      :html-to-pdf-options="{
        margin: [20, 10, 0, 10],
        filename: 'شهادة المرتب',
        jsPDF: {
          format: `a2`,
          // orientation: st == 16 ? 'landscape' : 'portrait',
          orientation: 'portrait',
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
          dpi: 300,
          letterRendering: true,
        },
      }"
      ref="html2Pdf"
      @beforeDownload="beforeDownload($event)"
    >
      <!-- <SalaryCertificate/> -->
      <section class="pdf-container d-flex" slot="pdf-content">
        <SalaryCertificate :allData="socialSolidarities" :date="MonthDate" />
      </section>
    </vue-html2pdf>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">البيانات المالية</h4>
            </div>
          </md-card-header>
          <form>
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>شهر المرتب</label>
                    <md-input disabled v-model="MonthDate"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>الرقم الوظيفي</label>
                    <md-input disabled v-model="JobNumber"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>الإسم</label>
                    <md-input disabled v-model="EmployeeName"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>رقم الملف المالي</label>
                    <md-input disabled v-model="FileNumber"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>اسم المصرف</label>
                    <md-input disabled v-model="BankName"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>اسم الفرع</label>
                    <md-input disabled v-model="BankBranchName"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>رقم الحساب</label>
                    <md-input
                      type="number"
                      disabled
                      v-model="AccountNumber"
                    ></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>المرتب الأساسي</label>
                    <md-input disabled v-model="BasicSalary"></md-input>
                  </md-field>
                </div>
                <div
                  v-if="!privateCompanyMode"
                  class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>المرتب الأساسي المحال من المالية</label>
                    <md-input v-model="NewBasicSalary"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>نسبة خصم الراتب</label>
                    <md-input v-model="SalaryPercentage"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>ساعات العمل</label>
                    <md-input disabled v-model="WorkHours"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>ساعات الحضور</label>
                    <md-input disabled v-model="PresentHours"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="!privateCompanyMode"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>الدرجة المالية</label>
                    <md-input disabled v-model="Degree"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="!privateCompanyMode"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>العلاوة المالية</label>
                    <md-input disabled v-model="Bonus"></md-input>
                  </md-field>
                </div>

                <!-- <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                    <label>الدرجة المالية</label>
                    <md-input disabled v-model="FinancialDegree"></md-input>
                  </md-field>
                </div> -->

                <!-- <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field :class="[{ 'md-error': failed }, { 'md-valid': passed }]">
                    <label>العلاوة المالية</label>
                    <md-input disabled v-model="FinancialBonuse"></md-input>
                  </md-field>
                </div> -->
              </div>
            </md-card-content>
          </form>
        </md-card>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">العلاوات والمكافأت</h4>
            </div>
          </md-card-header>
          <form>
            <md-card-content>
              <div class="md-layout">
                <div
                  v-for="(all, index) in allownce"
                  :key="index"
                  class="md-layout-item md-size-30 mb-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>{{ all.typesBonuse }}</label>
                    <md-input disabled v-model="all.value"></md-input>
                  </md-field>
                </div>

                <div
                  v-for="(all, index) in committee"
                  :key="index"
                  class="md-layout-item md-size-30 mb-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>{{ all.committee.name }}</label>
                    <md-input
                      disabled
                      v-model="all.committeeAllowance"
                    ></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>اجمالي العلاوات</label>
                    <md-input v-model="SumAllownce"></md-input>
                  </md-field>
                </div>

                <div
                  class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>مكافأة خاضعة للضرائب</label>
                    <md-input v-model="TaxableReward"></md-input>
                  </md-field>
                </div>

                <div
                  class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>مكافأة غير خاضعة للضرائب</label>
                    <md-input v-model="nonTaxableReward"></md-input>
                  </md-field>
                </div>
              </div>
            </md-card-content>
          </form>
        </md-card>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">العمل الإضافي</h4>
            </div>
          </md-card-header>
          <form>
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>ساعات الإضافي الأساسي</label>
                    <md-input disabled v-model="basicOverTime"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>قيمة العمل الإضافي الأساسي</label>
                    <md-input disabled v-model="basicOverTimeValue"></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>ساعات الإضافي العادي</label>
                    <md-input disabled v-model="standardOverTime"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>قيمة العمل الإضافي العادي</label>
                    <md-input
                      disabled
                      v-model="standardOverTimeValue"
                    ></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>ساعات الإضافي الممتاز</label>
                    <md-input disabled v-model="premiumOverTime"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>قيمة العمل الإضافي الممتاز</label>
                    <md-input
                      disabled
                      v-model="premiumOverTimeValue"
                    ></md-input>
                  </md-field>
                </div>
              </div>
            </md-card-content>
          </form>
        </md-card>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">خصم التأخير والغياب</h4>
            </div>
          </md-card-header>
          <form>
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>ساعات الغياب</label>
                    <md-input v-model="AbsencHours"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>خصم الغياب</label>
                    <md-input disabled v-model="AbsencValue"></md-input>
                  </md-field>
                </div>
              </div>
            </md-card-content>
          </form>
        </md-card>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">الخصميات</h4>
            </div>
          </md-card-header>
          <form>
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>إجمالي الاستقطاعات</label>
                    <md-input
                      type="number"
                      v-model="totalDeductions"
                    ></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field>
                    <label>نوع الضمان</label>
                    <md-select disabled v-model="WarrantyType">
                      <md-option value="1">لا يوجد ضمان</md-option>
                      <md-option value="2">مخفض </md-option>
                      <md-option value="3">ضمان عادي</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>حصة الضمان</label>
                    <md-input disabled v-model="WarrantyTax"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="!privateCompanyMode"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>حصة التضامن</label>
                    <md-input disabled v-model="SolidarityTax"></md-input>
                  </md-field>
                </div>

                <!-- <div
                  v-if="!privateCompanyMode"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>حصة الجهاد</label>
                    <md-input disabled v-model="JihadTax"></md-input>
                  </md-field>
                </div> -->

                <div
                  v-if="!privateCompanyMode"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>حصة جهة العمل</label>
                    <md-input disabled v-model="EmployerTax"></md-input>
                  </md-field>
                </div>

                <div
                  v-if="!privateCompanyMode"
                  class="md-layout-item md-size-30 mt-25 ml-15"
                >
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>حصة الخزانة</label>
                    <md-input disabled v-model="CabinetTax"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>مرتب مقدم</label>
                    <md-input v-model="PrepaidSalary"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>خصميات اخرى</label>
                    <md-input v-model="OtherDiscounts"></md-input>
                  </md-field>
                </div>
              </div>
            </md-card-content>
          </form>
        </md-card>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">الإجماليات</h4>
            </div>
          </md-card-header>
          <form>
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>اجمالي المرتب</label>
                    <md-input disabled v-model="TotalSalary"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>اجمالي الخصميات</label>
                    <md-input disabled v-model="TotalDiscounts"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>صافي المرتب</label>
                    <md-input disabled v-model="NetSalary"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label> فروقات المرتب</label>
                    <md-input v-model="Differences"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>فروقات العلاوات</label>
                    <md-input v-model="AllownacesDifferences"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>الراتب الخاضع للضريبة</label>
                    <md-input disabled v-model="TaxableSalary"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>ملاحظة</label>
                    <md-input v-model="Note"></md-input>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 mt-25 ml-15">
                  <md-field
                    :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                  >
                    <label>ملاحظة الخصميات</label>
                    <md-input v-model="DiscountsNote"></md-input>
                  </md-field>
                </div>

                <div
                  class="md-layout-item md-size-100 mt-25 mtb-25 center-content"
                >
                  <md-button @click="Save" class="md-success btn_nanosoft"
                    >حفظ</md-button
                  >
                  <md-button @click="print" class="md-info btn_nanosoft">
                    طباعة
                  </md-button>
                  <md-button @click="gobBack" class="md-black btn_nanosoft"
                    >رجوع</md-button
                  >
                </div>
                <Lodding v-if="lodding_bool" color="green" scale="0.4" />
              </div>
            </md-card-content>
          </form>
        </md-card>
      </div>
    </div>

    <!-- <div class="md-layout-item">
      <md-card>

        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">مقارنة المرتبات</h4>
          </div>
        </md-card-header>
        
        <md-card-content>
          <div class="md-layout flex-content-left">
            <div class="md-size-15 md-layout-item mt-25">
              <md-table-toolbar>
                <md-field>
                  <label for="pages">عدد النتائج</label>
                  <md-select v-model="pagination.perPage" name="pages">
                    <md-option
                      v-for="item in pagination.perPageOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                      >{{ item }}</md-option
                    >
                  </md-select>
                </md-field>
              </md-table-toolbar>
            </div>
          </div>

          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover mt-25"
          >
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="المقارنة حسب">{{
                item.compareBy
              }}</md-table-cell>

              <md-table-cell md-label="الشهر الحالي">{{
                item.currentMonthValue
              }}</md-table-cell>

              <md-table-cell md-label="الشهر السابق">{{
                item.previousMonthValue
              }}</md-table-cell>

              <md-table-cell md-label="الفارق">{{
                item.difference
              }}</md-table-cell>

              <md-table-cell md-label>
                <div class="md-just-icon md-info md-simple"></div>
              </md-table-cell>
            </md-table-row>
          </md-table>
          <div class="footer-table md-table">
            <table>
              <tfoot>
                <tr>
                  <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                  >
                    <div class="md-table-head-container md-ripple md-disabled">
                      <div class="md-table-head-label">{{ item }}</div>
                    </div>
                  </th>
                </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div> -->
  </div>
</template>

<script>
import Lodding from "../../../../Lodding.vue";

import axios from "../../../../components/service/HTTP";
// import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import moment from "moment";
import env from "../../../../../env";
import VueHtml2pdf from "vue-html2pdf";
import SalaryCertificate from "../../../../components/Reports/SalaryCertificate.vue";

export default {
  async created() {
    this.init();
    const styleValue = localStorage.getItem("privateCompanyMode");
    this.privateCompanyMode = styleValue === "true";

    console.warn("this.privateCompanyMode", this.privateCompanyMode);
  },
  components: {
    // Pagination,
    VueHtml2pdf,
    Lodding,
    SalaryCertificate,
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      privateCompanyMode: false,
      lodding_bool: false,
      socialSolidarities: "",
      MonthDate: null,
      JobNumber: 0,
      EmployeeName: "",
      FileNumber: 0,
      BankName: "",
      BankBranchName: "",
      AccountNumber: 0,
      BasicSalary: 0,
      NewBasicSalary: 0,
      SalaryPercentage: 0,
      WorkHours: 0,
      PresentHours: 0,
      Degree: 0,
      Bonus: 0,

      SumAllownce: "",
      basicOverTime: 0,
      basicOverTimeValue: 0,
      standardOverTime: 0,
      standardOverTimeValue: 0,
      premiumOverTime: 0,
      premiumOverTimeValue: 0,
      TotalSalary: 0,
      AbsencHours: 0,
      AbsencValue: 0,
      VacationTypeDiscountValue: 0,
      YearlyVacationDiscountHours: 0,
      YearlyVacationDiscountValue: 0,

      SanctionHours: 0,
      SanctionValue: 0,
      Differences: 0,
      AllownacesDifferences: 0,
      AdvanceRest: 0,
      totalDeductions: 0,
      WarrantyTax: 0,
      SolidarityTax: 0,
      // JihadTax: 0,
      EmployerTax: 0,
      CabinetTax: 0,
      WarrantyType: "1",
      PrepaidSalary: 0,
      JihadTaxableReward: 0,
      TaxableReward: 0,
      nonTaxableReward: 0,
      OtherDiscounts: 0,
      NetSalary: 0,

      TotalDiscounts: 0,
      TaxableSalary: 0,
      Note: "",
      DiscountsNote: "",

      EmployeeId: "",
      SalaryStatus: "1",
      GetLatestSalary: true,

      FinancialDegree: 0,
      FinancialBonuse: 0,

      tableData: [],
      allownce: [],
      committee: [],

      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["Titel", "Severity", "Status"],
      searchedData: [],
      fuseSearch: null,
    };
  },

  methods: {
    async print() {
      try {
        this.lodding_bool = true;
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let id = this.$route.params.id;

        const url = "/api/SalariesReports/GetSalaryReportPdf";

        const params = {
          EmployeeId: this.EmployeeId,
          date: moment(this.MonthDate).format("YYYY-MM-DD"),
        };

        const response = await this.$axios.get(url, {
          params,
          responseType: "blob",
        });

        this.lodding_bool = false;

        downloadFile(response.data);

        // await fetch(
        //   `https://nanosoft.live/hr-reports/api/SalariesReports/GetEmployeeSalaries?reportTypes=0&BaseUrl=${env.HR()}&token=${token}&Id=${id}
        // `
        // )
        //   .then((response) => {
        //     this.lodding_bool = false;
        //     return response.blob();
        //   })
        //   .then((blob) => {
        //     downloadFile(blob);
        //   });

        function downloadFile(blob, name = "file") {
          const href = URL.createObjectURL(blob);
          const a = Object.assign(document.createElement("a"), {
            href,
            style: "display:none",
            download: "تقرير شهادة المرتب.pdf",
          });
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(href);
          a.remove();
          // let T = localStorage.getItem("Nannotoken");
          // let token = atob(T);

          // let result = await axios.get(
          //   `${env.HR()}/api/SalariesReports/GetSalaryReport?EmployeeId=${this.EmployeeId}&Date=${this.MonthDate}`,
          //   {
          //     headers: { Authorization: "Bearer " + token },
          //   }
          // );

          // this.socialSolidarities = result.data.data;

          // this.$refs.html2Pdf.generatePdf();
        }
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    },
    async beforeDownload({ html2pdf, options, pdfContent }) {
      await html2pdf()
        .set(options)
        .set({ pagebreak: { avoid: "tr" } })
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          pdf.setFont("Amiri-Regular");
          // pdf.setR2L(true);
          pdf.setLanguage("ar-KW");
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(30);
            pdf.setTextColor(150);
            // pdf.text(
            //   this.companyName,
            //   pdf.internal.pageSize.getWidth() * 0.77,
            //   40,
            //   { lang: "ar" }
            // );
            // pdf.text(
            //   this.companyDesc,
            //   pdf.internal.pageSize.getWidth() * 0.63,
            //   55,
            //   { lang: "ar" }
            // );
            // pdf.text(
            //   "التوقيع",
            //   pdf.internal.pageSize.getWidth() * 0.1,
            //   pdf.internal.pageSize.getHeight() - 35,
            //   { lang: "ar" }
            // );
            // pdf.text(
            //   "التوقيع",
            //   pdf.internal.pageSize.getWidth() * 0.5,
            //   pdf.internal.pageSize.getHeight() - 35,
            //   { lang: "ar" }
            // );
            // pdf.text(
            //   "التوقيع",
            //   pdf.internal.pageSize.getWidth() * 0.9,
            //   pdf.internal.pageSize.getHeight() - 35,
            //   { lang: "ar" }
            // );
          }
        })
        .save();
    },

    round(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    },
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getFullYear() + "-" + (d.getMonth() + 1);
      } catch (error) {}
    },

    minusDate(d) {
      const date = new Date(d);
      date.setDate(date.getDate() - 25);
      return date;
    },

    minusOneMonth(d) {
      const date = new Date(d);
      date.setMonth(date.getMonth() - 1);
      return date;
    },

    async Save() {
      try {
        let T = localStorage.getItem("Nannotoken");

        let token = atob(T);
        let schema = {
          NewBasicSalary: this.NewBasicSalary,
          SalaryPercentage: this.SalaryPercentage,
          basicOverTime: this.basicOverTime,
          standardOverTime: this.standardOverTime,
          premiumOverTime: this.premiumOverTime,
          AbsencHours: this.AbsencHours,
          VacationTypeDiscountValue: this.VacationTypeDiscountValue,
          SanctionHours: this.SanctionHours,
          SanctionHours: this.SanctionHours,
          Differences: this.Differences,
          AllownacesDifferences: this.AllownacesDifferences,
          totalDeductions: this.totalDeductions,
          PrepaidSalary: this.PrepaidSalary,
          JihadTaxableReward: this.JihadTaxableReward,
          nonTaxableReward: this.nonTaxableReward,
          TaxableReward: this.TaxableReward,
          OtherDiscounts: Number(this.OtherDiscounts),
          Note: this.Note,
          DiscountsNote: this.DiscountsNote,
          SumAllowance: parseInt(this.SumAllownce),
        };

        let id = this.$route.params.id;
        let result = await axios.put(`${env.HR()}/api/Salaries/${id}`, schema, {
          headers: { Authorization: "Bearer " + token },
        });

        // this.NetSalary = result.data.data.netSalary;
        // this.TotalDiscounts = result.data.data.totalDiscounts;

        await this.init();
        return this.notifyVue("top", "center", "success", " تم الحفظ بنجاح ");
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          error.response.data.errors[Object.keys(error.response.data.errors)][0]
        );
      }
    },

    async init() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        let id = this.$route.params.id;
        let result = await axios.get(`${env.HR()}/api/Salaries/${id}`, {
          headers: { Authorization: "Bearer " + token },
        });

        this.EmployeeId = result.data.data.employeeId;
        this.allownce = result.data.data.allownce;
        this.committee = result.data.data.committee;
        this.SumAllownce = result.data.data.sumAllownce;

        const num = result.data.data.presentHours;
        this.MonthDate = this.convert(result.data.data.monthDate);
        this.JobNumber = result.data.data.jobNumber;
        this.EmployeeName = result.data.data.employeeName;
        this.FileNumber = result.data.data.fileNumber;
        this.BankName = result.data.data.bankName;
        this.BankBranchName = result.data.data.bankBranchName;
        this.AccountNumber = result.data.data.accountNumber;
        this.BasicSalary = result.data.data.basicSalary;
        this.NewBasicSalary = result.data.data.newBasicSalary;
        this.SalaryPercentage = result.data.data.salaryPercentage;
        this.WorkHours = result.data.data.workHours;
        this.PresentHours = Number(num.toFixed(1));
        this.Degree = result.data.data.degree;
        this.Bonus = result.data.data.bonus;
        this.FinancialDegree = result.data.data.financialDegree;
        this.FinancialBonuse = result.data.data.financialBonuse;

        this.standardOverTime = result.data.data.standardOverTime;
        this.basicOverTime = result.data.data.basicOverTime;
        this.basicOverTimeValue = result.data.data.basicOverTimeValue;
        this.standardOverTimeValue = result.data.data.standardOverTimeValue;
        this.premiumOverTime = result.data.data.premiumOverTime;
        this.premiumOverTimeValue = result.data.data.premiumOverTimeValue;
        this.TotalSalary = result.data.data.totalSalary;
        this.AbsencHours = Number(result.data.data.absencHours.toFixed(2));
        this.AbsencValue = result.data.data.absencValue;
        this.VacationTypeDiscountValue =
          result.data.data.vacationTypeDiscountValue;
        this.YearlyVacationDiscountHours =
          result.data.data.yearlyVacationDiscountHours;
        this.YearlyVacationDiscountValue =
          result.data.data.yearlyVacationDiscountValue;

        this.SanctionHours = result.data.data.sanctionHours;
        this.SanctionValue = result.data.data.sanctionValue;
        this.Differences = result.data.data.differences;
        this.AllownacesDifferences = result.data.data.allownacesDifferences;
        this.AdvanceRest = result.data.data.advanceRest;
        this.totalDeductions = result.data.data.totalDeductions;
        this.WarrantyTax = result.data.data.warrantyTax;
        this.SolidarityTax = result.data.data.solidarityTax;
        // this.JihadTax = result.data.data.jihadTax;
        this.EmployerTax = result.data.data.employerTax;
        this.CabinetTax = result.data.data.cabinetTax;
        this.WarrantyType = result.data.data.warrantyType;
        this.PrepaidSalary = result.data.data.prepaidSalary;
        this.JihadTaxableReward = result.data.data.jihadTaxableReward;
        this.nonTaxableReward = result.data.data.nonTaxableReward;
        this.TaxableReward = result.data.data.taxableReward;
        this.OtherDiscounts = result.data.data.otherDiscounts;
        this.NetSalary = result.data.data.netSalary;

        this.TotalDiscounts = result.data.data.totalDiscounts;
        this.TaxableSalary = result.data.data.taxableSalary;
        this.Note = result.data.data.note;
        this.DiscountsNote = result.data.data.discountsNote;

        // let result_differences = await axios.get(`${env.HR()}/api/Salaries/comparisons/${id}`, {
        //   headers: { Authorization: "Bearer " + token },
        // });

        // this.tableData = result_differences.data.data;
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    },

    gobBack() {
      this.$router.push("/pages/confirm_salary");
    },

    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
  },
};
</script>

<style>
.mb-25 {
  margin-bottom: 10px;
}
</style>
